import { Button } from '@abyss/web/ui/Button';
import { Flex } from '@abyss/web/ui/Flex';
import { Modal } from '@abyss/web/ui/Modal';
import { Text } from '@abyss/web/ui/Text';

import { adobeLinkTrackEvent } from '../../AdobeTagging/adobeLinkTrackEvent';

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  onLeaveWithoutSaving: () => void;
  onSaveAndClose: () => void;
  saveConfirmation?: string;
  cancelConfirmation?: string;
  confirmationTitle?: string;
}

export const CtaConfirmationModal = ({
  isOpen,
  onLeaveWithoutSaving,
  onSaveAndClose,
  saveConfirmation,
  cancelConfirmation,
  confirmationTitle,
}: Props) => {
  const handleSaveAndClose = () => {
    adobeLinkTrackEvent({
      name: saveConfirmation || 'Yes, save preference',
      location: 'modal:Confirmation modal',
    });
    onSaveAndClose();
  };

  const handleLeaveWithoutSaving = () => {
    adobeLinkTrackEvent({
      name: cancelConfirmation || 'No, leave without saving',
      location: 'modal:Confirmation modal',
    });
    onLeaveWithoutSaving();
  };

  return (
    <Modal
      css={{
        width: '348px',
        minHeight: 'fit-content',
        maxHeight: '228px',
        maxWidth: '348px',
        'abyss-modal-close-button': {
          display: 'none',
        },
      }}
      data-auto-testid="preferences-confirmation-modal"
      data-testid="preferences-confirmation-modal"
      isOpen={isOpen}
      size="medium"
      title=""
    >
      <Modal.Section>
        <Flex
          css={{
            padding: '16px 0',
            width: '348px',
            minHeight: 'fit-content',
            maxHeight: '100px',
            gap: '24px',
          }}
          direction="row"
        >
          <Text
            css={{
              fontSize: '28px',
              fontWeight: 700,
              fontStyle: 'bold',
              lineHeight: '120%',
              color: '#002677',
              gap: '28px',
            }}
            data-testid="confirmation-modal-title"
          >
            {confirmationTitle}
          </Text>

          <Flex
            css={{
              gap: '12px',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              width: '348px',
              minHeight: 'fit-content',
              maxHeight: '112px',
            }}
            direction="row"
          >
            <Button
              css={{ width: 'auto' }}
              data-auto-testid="save-preferences-button"
              data-testid="save-preferences-button"
              onClick={handleSaveAndClose}
              type="submit"
            >
              {saveConfirmation}
            </Button>
            <Button
              css={{ width: 'auto' }}
              data-auto-testid="leave-without-saving-button"
              data-testid="leave-without-saving-button"
              onClick={handleLeaveWithoutSaving}
              type="button"
              variant="outline"
            >
              {cancelConfirmation}
            </Button>
          </Flex>
        </Flex>
      </Modal.Section>
    </Modal>
  );
};
